import {Component, OnInit, Input} from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Response, RequestOptions} from '@angular/http';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Globals} from './globals';

import {InfiniteScrollModule} from 'ngx-infinite-scroll';

import { Overlay } from 'ngx-modialog';

import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule, Modal, bootstrap3Mode } from 'ngx-modialog/plugins/bootstrap';

// run the plugin to work with version 4 of bootstrap
bootstrap3Mode();

import * as $ from 'jquery';

@Component({
    selector: 'my-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class FooterComponent implements OnInit {

    public isCollapsed:boolean = true;

    constructor(public router: Router,
                private http: HttpClient,
                private globals: Globals,
                public modal: Modal) {
    }

    ngOnInit(): void {
        //console.log('hello');


    }
    public redirect(idStr) {
        this.router.navigate(['./' + idStr]);
    }

    public onClick() {
        const dialogRef = this.modal.alert()
            .size('lg')
            .showClose(true)
            .title('Privacy Policy')
            .body(`
            <p>Thank you for visiting our site!</p>

            <p>We are committed to respecting your right to privacy and will protect it when you visit our website.</p>
            
            <p>This privacy policy explains our online information practices only, including how we collect and use your personal information. It covers information collected on this website only. It does not apply to other sites you reach through our site. We encourage you to read the Privacy Policies of those other parties to learn how they collect and use information about you.</p>
            
            <p>To assist you with reading our privacy policy, we have provided answers to the following questions you may find most important:</p>
            
            <p>What information do we collect automatically online?</p>
            
            <p>When you visit our website, we collect information about your visit that does not identify you personally. We can tell the type of computer, browser, and Web service you are using. We also know the date, time, and pages you visit. Collecting this information helps us design the site to suit your needs. If you are registered with our site, we will try to automatically identify you so that you don't have to sign-in upon each return visit.</p>
            
            <p>What additional information do we collect about you online?</p>
            
            <p>If you ask us a question or register with this site, we collect your contact information and additional information that you volunteer so that we can respond to your request. We'll track your online activity and the information we collect is used to improve the content of our Web pages, used to customize the content and/or layout of our pages to optimize your website experience.</p>
            
            <p>If you supply us with your telephone number online you may receive telephone contact from us with information regarding your visit to our website. If you do not wish to receive such telephone calls, please let us know by responding to the initial email that you receive from us.</p>
            
            <p>Do we share the information we collect online?</p>
            
            <p>We do not share any information about you unless we are required by law to do so for authorized law enforcement.</p>
            
            <p>How do we handle email communication?</p>
            
            <p>If you provide us with your email address and you choose to correspond with us via email, we may choose to store these correspondences together with your registration information.  Occasionally, we may also send you email notifications relating to new offers that we feel that you might find valuable.  If at any time you wish to stop receiving these offers, you may click the unsubscribe link on any of these communications to opt-out or email us back directly to request your email address be removed from our database.</p>
            
            <p>Do we use cookies or other tracking devices?</p>
            
            <p>A "cookie" is a small text file that is stored on your computer and makes it easy for you to move around a website without having to continually re-enter your name, password, preferences, and so on. We use cookies to store visitors' preferences, record user-specific information on what pages users access or visit, customize Web page content based on visitors' browser type or other information that the visitor sends.</p>
            
            <p>What if I am on the Do Not Call Registry?</p>
            
            <p>If you supply us with a phone number, then you are giving us permission to call you even if you are on the Do Not Call Registry. If you choose not to be bothered, please let us know.   We will add you to our own Do Not Call list.</p>
            
            <p>Opt-out</p>
            
            <p>You may stop recieving all email communications from us. <a href="/unsubscribe.php" target="_blank"> Click here to unsubscribe.</a></p>`)
            .open();
    }
}